import { Modal, Form, Button } from "antd";
import { useEffect } from "react";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import StyledTextInput from "src/components/reusable/StyledTextInput";

interface EditUserModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (_values: EditUserFormValues) => void;
  user: {
    name: string;
    email: string;
    status: string;
    plan: string;
  } | null;
}

interface EditUserFormValues {
  name: string;
  email: string;
  status: string;
  plan: string;
}

const EditUserModal: React.FC<EditUserModalProps> = ({
  open,
  onClose,
  onSubmit,
  user,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.name,
        email: user.email,
        status: user.status,
        plan: user.plan,
      });
    }
  }, [user, form]);

const handleFinish = (values: EditUserFormValues) => {
    onSubmit(values);
  };

  return (
    <Modal
      title="Edit User"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <StyledTextInput  aria-label="User Name"/>
        </Form.Item>

        <Form.Item label="Email" name="email">
          <StyledTextInput readOnly disabled  aria-label="User Email"/>
        </Form.Item>

        <Form.Item label="Plan" name="plan">
          <StyledDropdown
            disabled
            aria-label="User Plan"
            options={[
              { value: "Basic", label: "Basic" },
              { value: "Pro", label: "Pro" },
              { value: "Enterprise", label: "Enterprise" },
            ]}
            popupClassName="custom-dropdown-menu"
          />
        </Form.Item>

        <Form.Item label="Status" name="status" rules={[{ required: true }]}>
         <StyledDropdown
  placeholder="Select status"
  aria-label="User Status"
  options={[
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
    { value: "Suspended", label: "Suspended" },
  ]}
  popupClassName="custom-dropdown-menu"
/>
        </Form.Item>

        <div className="flex justify-end gap-2">
          <Button className="button button--outline" onClick={onClose}aria-label="Cancel" style={{marginRight:"10px"}}>Cancel</Button>
          <Button className="button button--primary" type="primary" htmlType="submit" aria-label="Save Changes">
            Save Changes
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
